import React from 'react';

export const PdfHuchaContent = ({
	targetRef,
	layerContent,
}: {
	targetRef: React.RefObject<HTMLDivElement>;
	layerContent: () => JSX.Element | null;
}) => {
	return (
		<div
			ref={targetRef}
			style={{
				position: 'absolute',
				left: '-9999px',
				width: '1024px',
				overflow: 'visible',
				pageBreakInside: 'avoid',
				breakInside: 'avoid',
			}}
		>
			{layerContent()}
		</div>
	);
};
